import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { BusinessTechnicalInstallationMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/business-technical-installation-metadata/business-technical-installation-metadata.component.abstract';

@Component({
  selector: 'app-business-technical-installation-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './business-technical-installation-metadata-v2.component.html',
  styles: 'app-card { min-height: auto; }',
})
export class BusinessTechnicalInstallationMetadataV2Component extends BusinessTechnicalInstallationMetadataComponentAbstract {}
